 <router-outlet></router-outlet>
 <p-toast />
 <app-analytics-consent-bar />
